import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesGreaterThan } from './ITypeValidatesGreaterThan';

export class GreaterThanValidator
  implements ValidatorInterface<ITypeValidatesGreaterThan>
{
  name = 'GreaterThan';

  friendlyName = 'Greater Than';

  arrayOnly = false;

  array = false;

  description = 'Field must be greater than this other field.';

  types = ['Percentage', 'Currency', 'Number', 'DateTime'];

  properties = {
    value: {
      type: 'Key',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesGreaterThan) {
    type.addGreaterThanValidator(this);
  }
}

const greaterThanValidator = new GreaterThanValidator(undefined);

ValidatorRegistry.register(GreaterThanValidator, greaterThanValidator.name);

export { greaterThanValidator };
